export type SupportRequestHandler = () => void;

let handler: SupportRequestHandler | null = null;

export const registerSupportRequestHandler = (
  nextHandler: SupportRequestHandler | null
) => {
  handler = nextHandler;
};

export const getSupportRequestHandler = (): SupportRequestHandler | null =>
  handler;
